<div class="host ___dashboard" [class.show]="show">

  <div class="head">
    <div class="left">
      <ul class="tabs">        
        <!-- <li *ngIf="withLibrary">
          <a href="javascript:void(0)" [class.active]="tab==='library'" (click)="tab='library'">
            <i class="icon-medium-tint icon-dashboard-media-library"></i>
            <span>Library</span>
          </a>
        </li> -->
        <li>
          <a href="javascript:void(0)" [class.active]="tab==='upload'" (click)="tab='upload'">
            <i class="icon-medium-tint icon-dashboard-media-upload"></i>
            <span>Upload</span>
          </a>
        </li>
        <!-- <li>
          <a href="javascript:void(0)" [class.active]="tab==='editor'" (click)="tab='editor'">
            <i class="icon-medium-tint icon-dashboard-media-editor"></i>
            <span>Editor</span>
          </a>
        </li> -->
      </ul>
    </div>
    <div class="right">
      <a href="javascript:void(0)" (click)="closeAndReset()">X</a>
    </div>
  </div>

  <div class="body">

    <!-- <div class="library" *ngIf="withLibrary && tab==='library'"></div> -->

    <div class="upload" *ngIf="tab==='upload'">

      <ng-container *ngIf="selectedFile; else uploadInput">

        <div class="cropper" *ngIf="fileDataUrl">
          <image-cropper
            [url]="fileDataUrl"
            [options]="cropperOptions"
            [resultOptions]="cropperResultOptions"
            (change)="cropResult=$event"
          ></image-cropper>
          <div class="sizing">
            <input
              class="form-control"
              type="number"
              [value]="imageCropping?.width"
              [disabled]="!imageCropping?.unenforced"
              (change)="croppingWidthChanges($event)">
            <div>X</div>
            <input
              class="form-control"
              type="number"
              [value]="imageCropping?.height"
              [disabled]="!imageCropping?.unenforced"
              (change)="croppingHeightChanges($event)">
          </div>
          <div class="action">
            <a href="#" class="button-primary" (click)="doneCropping();false;">Crop & Upload</a>
          </div>
        </div>

        <div class="uploading" *ngIf="uploading">
          <div class="name">File name: {{ uploading.name }}</div>
          <div class="size">File size: {{ uploading.size | filesize }}</div>
          <ng-container *ngIf="uploadResult; else statusShow">
            <div class="upload-size" *ngIf="uploadResult.metadata; let metadata;">
              Upload size: {{ metadata.size | filesize }}
            </div>
            <div class="path">Upload path: <a href="#">{{ uploadResult.fullPath }}</a></div>
            <div class="url">Download URL: <a [href]="uploadResult.downloadUrl" target="_blank">Open link</a></div>
          </ng-container>
          <ng-template #statusShow>
            <div class="status">
              <progress [value]="uploading.uploadPercent$ | async" max="100"></progress>
            </div>
          </ng-template>
        </div>

      </ng-container>

      <ng-template #uploadInput>
        <input type="file" (change)="selectFile($event)">
      </ng-template>
  
    </div>

    <!-- <div class="editor" *ngIf="tab==='editor'">
      <div id="tui-image-editor"></div>
    </div> -->

  </div>

  <div class="foot">
    <div class="left">
      <label class="option">
        <input type="checkbox" [(ngModel)]="closeOnCompleted">
        <span>Close on completed</span>
      </label>
    </div>
    <div class="right">
      <a href="#" class="button-primary" (click)="closeAndReset();false;">Close</a>
    </div>
  </div>

</div>